"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inlineGlossary = void 0;
const tippy_js_1 = __importDefault(require("tippy.js"));
require("tippy.js/dist/tippy.css"); // optional for styling
function inlineGlossary() {
    document.querySelectorAll('.wysiwyg p, .wysiwyg ul, .text-image p, .text-image ul').forEach(function (tag) {
        let inner = tag.innerHTML;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        for (const searchKey in glossaryDataLayer) {
            const re = new RegExp('\\b' + searchKey + '\\b(?![/|".-])', 'gi');
            inner = inner.replaceAll(re, 'REPLACE_' + searchKey);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        for (const searchKey in glossaryDataLayer) {
            const replaceHtml = '<span data-tippy-content="' +
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                glossaryDataLayer[searchKey] +
                '" class="tippy-info-box tippy-' +
                searchKey +
                '">' +
                searchKey +
                '</span>';
            inner = inner.replaceAll('REPLACE_' + searchKey, replaceHtml);
        }
        tag.innerHTML = inner;
    });
    (0, tippy_js_1.default)('[data-tippy-content]', { allowHTML: true });
}
exports.inlineGlossary = inlineGlossary;
